module.exports = __webpack_public_path__ + "b5972a22a3a03e8912341d862eee91bb.svg";